import { render } from "./PerfilContacto.vue?vue&type=template&id=276a07b8"
import script from "./PerfilContacto.vue?vue&type=script&lang=ts"
export * from "./PerfilContacto.vue?vue&type=script&lang=ts"
script.render = render

export default script